const KeenSlider = window.KeenSlider

const { setInitialised, useCounter, useProgress } = window.BAO.Carousel.plugins

class AdventElementCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide || this.els?.slide?.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 8,
        },
      },
      [
        setInitialised(),
        useCounter({
          counter: this.els?.counter?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('advent-element-carousel')) {
  customElements.define('advent-element-carousel', AdventElementCarousel)
}
